export enum ProductTabs {
    Prices = 'Prices',
    // List = 'List',
    Groups = 'Groups',
    MobileGroups = 'Mobile Groups',
}
